export default __webpack_public_path__ + "static/media/S_Flex_Logo_Coloured.bfe014e3.png";